var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThickTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.4 162.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a09f9f;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.52,19.7v-4.7h5.49c3.13,0,5.67-2.54,5.67-5.67v-3.66c0-3.13-2.54-5.67-5.67-5.67h-34.62c-3.13,0-5.67,2.54-5.67,5.67v3.66c0,3.13,2.54,5.67,5.67,5.67h5.49v4.7C25.95,25.34,0,54.9,0,90.42c0,39.54,32.16,71.7,71.7,71.7s71.7-32.16,71.7-71.7c0-35.52-25.95-65.08-59.88-70.72Zm-11.82,124.42c-29.61,0-53.7-24.09-53.7-53.7s24.09-53.7,53.7-53.7,53.7,24.09,53.7,53.7-24.09,53.7-53.7,53.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.52,
    y1: 89.52,
    x2: 93.48,
    y2: 67.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.55,84.44h0c1.06,1.75,1.67,3.79,1.67,5.98,0,6.36-5.16,11.52-11.52,11.52s-11.52-5.16-11.52-11.52,5.16-11.52,11.52-11.52c1.62,0,3.16.34,4.56.94l14.75-14.75c1.36-1.37,3.58-1.37,4.95,0s1.36,3.58,0,4.94l-14.41,14.41Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickTimer);
export default __webpack_public_path__ + "static/media/thick-timer.bed0ee8d04b76ff9f8443f7be423504d.svg";
export { ForwardRef as ReactComponent };